<header>
    <a routerLink="dashboard">
        <img src="./assets/logo_inverted.svg" />
    </a>

    <div class="menu">
        <a routerLinkActive="active-link" routerLink="dashboard">
            <ng-container i18n="@@Dashboard">Dashboard</ng-container>
        </a>
        <a routerLinkActive="active-link" routerLink="orders">
            <ng-container i18n="@@Tests">Tests</ng-container>
        </a>
        <a routerLinkActive="active-link" routerLink="chair-orders">
            <ng-container i18n="@@WaterQuality">Water quality</ng-container>
        </a>
        <a routerLinkActive="active-link" routerLink="invoices">
            <ng-container i18n="@@Invoices">Invoices</ng-container>
        </a>
        <a routerLinkActive="active-link" routerLink="practices">
            <ng-container i18n="@@Practices">Practices</ng-container>
        </a>
        <a routerLinkActive="active-link" routerLink="purchaseorders">
            <ng-container i18n="@@KitRequests">Kit requests</ng-container>
        </a>
    </div>

    <button mat-button [matMenuTriggerFor]="menu">
        <ng-container i18n="@@Account">Account</ng-container><mat-icon>arrow_drop_down</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
        <div *ngIf="authService.userInfo$ | async as userInfo">
            <button mat-menu-item routerLink="profile">
                <mat-icon>account_circle</mat-icon>
                <span i18n="@@Profile">Profile</span>
            </button>
            <button mat-menu-item routerLink="team">
                <mat-icon>people</mat-icon>
                <span i18n="@@Team">Team</span>
            </button>
            <button mat-menu-item routerLink="integrations">
                <mat-icon>integration_instructions</mat-icon>
                <span i18n="@@ExactIntegration">Integrations</span>
            </button>
            <button mat-menu-item (click)="authService.login()" *ngIf="!userInfo.isLoggedIn">
                <mat-icon>expand_less</mat-icon>
                <span i18n="@@LogIn">Log in</span>
            </button>
            <button mat-menu-item (click)="authService.logout()" *ngIf="userInfo.isLoggedIn">
                <mat-icon>exit_to_app</mat-icon>
                <span i18n="@@LogOut">Log out</span>
            </button>
            <div style="font-size: x-small; text-align: center; margin-top: 12px"><span i18n="@@version">version</span> {{ version }}</div>
        </div>
    </mat-menu>
</header>

<div class="wrapper">
    <router-outlet></router-outlet>
</div>
